import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { CompanyDetail } from '../../models/company-detail.model';
import { CompanyService } from '../../services/company.service';
import { ModalComponent } from 'src/app/core/components/modal/modal.component';
import { CompanyListRefresh } from '../../services/company-list.refresh';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';
import { NotificationType } from 'src/app/core/models/ui-notification.model';
import { TariffDetail } from '../../models/tariff-detail.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-company-detail',
  templateUrl: './company-detail.component.html',
  styleUrls: ['./company-detail.component.css']
})
export class CompanyDetailComponent implements OnInit {

  form = new FormGroup({});
  company: CompanyDetail;
  tariffs: TariffDetail[];

  constructor(
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private companyListRefresh: CompanyListRefresh,
    private uiNotificationService: UINotificationService,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    this.company = this.route.snapshot.data.company;
    const response = this.route.snapshot.data.tariffs;
    this.tariffs = response.body;
    const defaultTariffCode = this.tariffs[0].code;
    this.form.addControl('isActive', new FormControl(this.company.isActive));
    this.form.addControl('address', new FormGroup({
      street: new FormControl('', Validators.required),
      town: new FormControl('', Validators.required),
      zipcode: new FormControl('', [Validators.required, Validators.minLength(5)]),
      country: new FormControl('CZ', Validators.required)
    }));

    this.form.patchValue({
      address: {
        street: this.company.address.street,
        town: this.company.address.town,
        zipcode: this.company.address.zipCode,
        country: this.company.address.country
      }
    });

    this.form.addControl('company', new FormGroup({
      name: new FormControl('', Validators.required),
      ico: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]),
      tariff: new FormControl(defaultTariffCode, Validators.required),
    }));

    if (this.company) {
      this.form.patchValue({
        company: {
          name: this.company.name,
          ico: this.company.ico,
          tariff: this.company.tariff.code
        }
      });
    }
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onSubmit(modal: ModalComponent) {
    if (this.form.valid) {
      this.companyService.update({
        id: this.company.id,
        name: this.form.get('company.name').value,
        ico: this.form.get('company.ico').value,
        isActive: this.form.get('isActive').value,
        tariffCode: this.form.get('company.tariff').value,
        street: this.form.get('address.street').value,
        town: this.form.get('address.town').value,
        zipcode: this.form.get('address.zipcode').value,
        country: this.form.get('address.country').value
      }).subscribe(() => {
        this.companyListRefresh.refresh();
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Firma byla aktualizována'
        });
        modal.closeModal(null);
      });
    }
  }

}
